import { FormattedMessage } from 'react-intl'
import { Box } from '@mui/material'
import { Button } from '@carto/meridian-ds/components'
import CardGroupHeader from 'features/common/ui/Cards/CardGroupHeader/CardGroupHeader'
import { ArrowForward } from '@mui/icons-material'
import { NavLink } from 'react-router-dom'

export function HomeDatasetsHeader({ withExploreButton, titleId }: { withExploreButton?: boolean; titleId?: string }) {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="flex-end">
      <CardGroupHeader titleId={`${titleId ? titleId : 'home.datasets.title'}`} titleVariant="h6" />
      {withExploreButton && (
        <Box display="flex" mb={3}>
          <Button component={NavLink} to="/data" color="primary" size="small" endIcon={<ArrowForward />}>
            <FormattedMessage id="home.datasets.explore" />
          </Button>
        </Box>
      )}
    </Box>
  )
}

export default HomeDatasetsHeader
